"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  margin-right: 10px;\n  transform: rotate(", ");\n  ", ";\n  ", ";\n"], ["\n  display: flex;\n  margin-right: 10px;\n  transform: rotate(", ");\n  ", ";\n  ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n  "], ["\n    display: flex;\n    align-items: center;\n  "]),
    _templateObject3 = _taggedTemplateLiteral(["\n    width: 11px;\n    height: 5px;\n    stroke-width: 2px;\n  "], ["\n    width: 11px;\n    height: 5px;\n    stroke-width: 2px;\n  "]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div.withConfig({
  displayName: "IconContainer__Container",
  componentId: "sc-15aj57-0"
})(_templateObject, function (props) {
  return props.rotation || 0;
}, function (props) {
  return props.center && (0, _styledComponents.css)(_templateObject2);
}, function (props) {
  return props.small && (0, _styledComponents.css)(_templateObject3);
});

exports.default = Container;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-icons/dist/icons/IconContainer.js
// module id = 33
// module chunks = 168707334958949